// ---------------------------------------
// Themes.js
// Plugin controlling Themes
// ---------------------------------------

import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'

const Themes = {
    possibilities: window.__theme_def._possibilities,
    systemThemeIndex: window.__theme_def._system_index,
    lightThemeIndex: window.__theme_def._light_index,
    darkThemeIndex: window.__theme_def._dark_index,
    themeStorageName: window.__theme_def._theme_store_name,
    html: document.getElementsByTagName('html')[0],
    radioButtons: document.querySelectorAll('.radiobtn[name=theme]'),
    os: '',

    Init: function() {
        // Do it, only if theme radios are available
        if(!Themes.radioButtons.length) { return; }
        Themes.os = Utils.UserAgent.OSName();
        Themes.SetTheme(Themes.GetTheme());
        Themes.ApplyTheme();
        Themes.ObjectModelActions.RadioInit();
        Themes.ObjectModelActions.SystemName();
        Themes.ObjectModelActions.InitDefaultDarkMode();
        Themes.Listeners.Selector();
    },

    GetTheme: function() {
        return localStorage.getItem(Themes.themeStorageName) || Themes.possibilities[0];
    },

    GetThemeBySystem: function() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? Themes.possibilities[Themes.darkThemeIndex] : Themes.possibilities[Themes.lightThemeIndex];
    },

    SetTheme: function(theme) {
        if (!Themes.possibilities.includes(theme)) {
            // eslint-disable-next-line no-console
            console.error(`Theme ${theme} does not exist.`);
            return;
        }
        localStorage.setItem(Themes.themeStorageName, theme);
    },

    ApplyTheme: function() {
        let applyTheme = Themes.GetTheme() === Themes.possibilities[Themes.systemThemeIndex] ? Themes.GetThemeBySystem() : Themes.GetTheme();
        Themes.ClearTheme();
        Themes.html.classList.add(applyTheme);
        Themes.ObjectModelActions.SetHtmlThemeBgValue(Themes.ObjectModelActions.GetComputedBodyBackground());
    },

    ClearTheme: function() {
        Themes.html.classList.remove(...Themes.possibilities);
    },
    
    ObjectModelActions: {
        RadioInit: function() {
            const theme = Themes.GetTheme();
            // uncheck all
            Themes.radioButtons.forEach(radio => {
                radio.checked = false;
            });
            // check value by storage
            document.querySelector(`.radiobtn[name=theme][value=${theme}]`).checked = true;
        },

        SystemName: function() {
            const systemThemeLabels = document.querySelectorAll('.system-theme-label');
            systemThemeLabels.forEach(label => {
                label.innerHTML = label.innerHTML.replace('[SYSTEM]', Themes.os !== '' ? `systému ${Themes.os}` : 'Vašeho systému');
            })
        },

        GetComputedBodyBackground: function() {
            const body = document.querySelector('html body');
            return window.getComputedStyle(body).backgroundColor;
        },

        SetHtmlThemeBgValue: function(value) {
            const bgColor = value.replaceAll(' ', '') === "rgba(0,0,0,0)" ? 'white' : value ;
            document.querySelector(':root').style.setProperty('--theme-bg', bgColor);
        },

        InitDefaultDarkMode: function() {
            // init default dark mode
            let pageDarkModeEnabled = window.PageData.pageDarkModeEnabled;
            if (pageDarkModeEnabled !== 'undefined' && pageDarkModeEnabled) {
                let originalTheme = Themes.GetTheme();
                Themes.SetTheme(Themes.possibilities[Themes.darkThemeIndex]);
                Themes.ApplyTheme();
                Themes.SetTheme(originalTheme);
            }
        }
    },
    Listeners: {

        Selector: function (){
            Themes.radioButtons.forEach(radio => {
                radio.addEventListener('change', () => {
                    const themeSelected = radio.value;
                    Themes.SetTheme(themeSelected);
                    Themes.ApplyTheme();
                });
            });
        }
    }

}

window.Themes = Themes;
export default Themes;